<template>
  <div class="candidate">
    <el-tabs v-model="current">
      <el-tab-pane label="人岗匹配" name="first">
        <match :positionType="positionType" :id="id" :tabName="current" :searchInfo="searchInfo" />
      </el-tab-pane>
      <el-tab-pane label="全网搜索" name="second">
        <all-search
          :positionType="positionType"
          :id="id"
          :tabName="current"
          :searchInfo="searchInfo"
        />
      </el-tab-pane>
      <el-tab-pane label="沟通列表" name="third">
        <communication-list
          :id="id"
          :tabName="current"
          :searchInfo="searchInfo"
          :positionType="positionType"
        />
      </el-tab-pane>
    </el-tabs>
    <el-button
      v-if="current === 'third'"
      type="primary"
      icon="icon-jr-icon-add"
      class="add"
      size="mini"
      @click="addItem"
    >
      添加
    </el-button>
  </div>
</template>

<script>
import match from './match'
import allSearch from './allSearch'
import communicationList from './communicationList'

export default {
  name: 'Candidate',

  components: {
    allSearch,
    communicationList,
    match
  },

  data() {
    return {
      current: 'first'
    }
  },
  computed: {
    id() {
      return Number(this.$route.query.id)
    },
    positionType() {
      return this.$route.query.positionType
    },
    searchInfo() {
      return JSON.parse(this.$route.query.searchInfo)
    },
    tabName() {
      return this.$route.query.tabName
    }
  },
  watch: {
    tabName: {
      handler: function (newVal) {
        if (newVal) {
          this.current = newVal
        }
      },
      immediate: true
    }
  },
  created() {
    this.$store.commit('changeQueryInfo', this.searchInfo)
  },
  methods: {
    addItem() {
      this.$router.push({
        name: 'TalentMessage',
        query: {
          tabName: this.current,
          id: this.id,
          positionType: this.positionType,
          searchInfo: JSON.stringify(this.searchInfo)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.candidate {
  position: relative;
  .add {
    position: absolute;
    top: 2px;
    right: 15px;
    /deep/ .icon-jr-icon-add {
      font-size: 14px;
    }
  }
}
/deep/.is-top {
  font-size: 18px;
}
</style>
